export const canBeQuestionRespondent = user =>
  ['administrateur', 'conseiller social'].includes(user?.role) ||
  (user?.role === 'ergothérapeute' && user?.ergoQualification === 'ergothérapeute interne');

// The questions space is opened account by account from the operator profile; the API decides.
export const canManageQuestions = user => user?.companyQuestionRespondent === true;

// Asking is switched on from the server once the respondents are in place; the API refuses it until then.
export const canAskQuestions = user =>
  user?.companyQuestionsOpen === true &&
  ['référent entreprise', 'coordinateur entreprises'].includes(user?.role);

export const questionState = question => {
  if (question.response?.trim() || question.respondedAt || question.status === 'processed')
    return 'processed';
  return question.status === 'changes_requested' ? 'other' : 'open';
};

const delayLevels = {
  on_time: { className: 'qq-delay-on-time', label: 'Moins de 48 h ouvrées' },
  warning: { className: 'qq-delay-warning', label: 'Entre 48 h et 5 jours ouvrés' },
  late: { className: 'qq-delay-late', label: 'Plus de 5 jours ouvrés' },
};

export const questionDelay = question =>
  questionState(question) === 'open' ? delayLevels[question.responseDelayLevel] : undefined;

export const questionStateLabels = {
  open: 'Sans réponse dans BAM',
  processed: 'Traitée',
  other: 'Échange antérieur',
};

export const initials = name =>
  (name || 'Entreprise')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(word => word[0])
    .join('')
    .toUpperCase();
